import React, { useCallback } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import moment from 'moment';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import { Tab, Tabs } from '@material-ui/core';
import { Licenses } from './Licenses';

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
});

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function LicenseList({ licenses }) {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const isNotExpired = license =>
    new Date(license.endDate) > new Date() || license.status === 'NEW';

  return (
    <>
      <Typography variant="h5" gutterBottom>
        Licenses
      </Typography>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange}>
          <Tab label="Active" {...a11yProps(0)} />
          <Tab label="Expired (Renewable)" {...a11yProps(1)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <Licenses
          licenses={licenses.filter(license => isNotExpired(license))}
        />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <Licenses
          licenses={licenses.filter(license => !isNotExpired(license))}
        />
      </CustomTabPanel>
    </>
  );
}
